import { render, staticRenderFns } from "./SnapshotDetailsForm.vue?vue&type=template&id=3828c11b"
import script from "./SnapshotDetailsForm.vue?vue&type=script&lang=js"
export * from "./SnapshotDetailsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports